import * as React from 'react';

import { Helmet } from 'react-helmet-async';
import { useLoaderData } from 'react-router-dom';

import { CategoryFormContext } from 'context';
import type { Category as CategoryConfig, ComponentMode } from 'types';

import { CategoryForm, CategoryHeader } from './components';

type CategoryProps = {
  mode: ComponentMode;
};

export default function Category({ mode }: CategoryProps) {
  const data = useLoaderData() as CategoryConfig | undefined;

  const { title: categoryTitle, status } = data ?? {};
  const isUpdatedMode = mode === 'Update';

  const step = 1;
  const title = isUpdatedMode ? categoryTitle : 'افزودن دسته‌بندی‌ جدید';
  const defaultTitle = isUpdatedMode ? categoryTitle : '';
  const defaultStatus: typeof status = isUpdatedMode ? status : 'Active';

  return (
    <React.Fragment>
      <Helmet>
        <title>{`${title} | کاشی لند`}</title>
      </Helmet>
      <CategoryHeader>{title}</CategoryHeader>
      <CategoryFormContext
        mode={mode}
        step={step}
        defaultStatus={defaultStatus}
        defaultTitle={defaultTitle}
        ownerType='Category'
        {...(isUpdatedMode ? data : {})}
      >
        <CategoryForm />
      </CategoryFormContext>
    </React.Fragment>
  );
}
